import { render, staticRenderFns } from "./BookingsV2.vue?vue&type=template&id=030bb3e1&scoped=true&"
import script from "./BookingsV2.vue?vue&type=script&lang=js&"
export * from "./BookingsV2.vue?vue&type=script&lang=js&"
import style0 from "./BookingsV2.vue?vue&type=style&index=0&id=030bb3e1&scoped=true&lang=css&"
import style1 from "./BookingsV2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030bb3e1",
  null
  
)

export default component.exports